import script from "./QDialogTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./QDialogTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./QDialogTemplate.vue?vue&type=style&index=0&id=45a8c8c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a8c8c1"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCardSection,QSeparator,QCardActions});
